/**
 * TanStack Router configuration
 */

import { createRouter, RouterProvider } from '@tanstack/react-router';
import { routeTree } from './routeTree.gen';
import { wireRouteChangeTracking } from './lib/routeUsageTracking';

// Create the router instance
export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
});

// Route-change usage tracking (issue #1451, part of epic #1448) — see
// routeUsageTracking.ts for why `onLoad` doesn't double-fire on
// preloads/redirects.
wireRouteChangeTracking(router);

// Register router type for type-safe navigation
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

/**
 * Router component wrapper
 */
export function Router(): JSX.Element {
  return <RouterProvider router={router} />;
}

export default Router;
